import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { WishlistToggleComponentDef } from '@df/session/wishlist/wishlist-toggle.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from '../../../ui/api/action.component';

type AnimationState = 'idle' | 'animating' | 'completed';

@Component({
    selector: 'wishlist-toggle',
    templateUrl: 'wishlist-toggle.html',
    styleUrls: ['./wishlist-toggle.scss'],
    standalone: true,
    imports: [NgClass, ActionComponent, TranslationModule]
})
export class WishlistToggleComponent extends WishlistToggleComponentDef {
    @Input()
    parentId?: number;

    @Input()
    gridSize?: number;

    animationState: AnimationState = 'idle';

    override get inWishlist(): boolean {
        if (!!this.item) {
            return true;
        }
        const items = this.productId && this.wishlist.getItemsByProduct(this.productId);
        return (items && items.length > 0) || this.parentInWishlist;
    }

    get parentInWishlist(): boolean {
        const parents = this.parentId && this.wishlist.getItemsByProduct(this.parentId);
        return parents ? parents.length > 0 : false;
    }

    override toggle = async (): Promise<void> => {
        if (this.animationState === 'animating') {
            return;
        }

        const wasInWishlist = this.inWishlist;

        if (!wasInWishlist) {
            this.animationState = 'animating';
            this.changeDetectorRef.detectChanges();

            this.timeoutService.setTimeout(() => {
                this.animationState = 'idle';
                this.changeDetectorRef.detectChanges();
            }, 1200);
        }

        if (this.item || this.productId) {
            this.wishlist.toggle(this.status, (this.item || this.productId)!);
        }
    };
}
